import React from 'react'

const TextInput = ({ label, onClick, containerStyle, errors, touched, onChange, onBlur, value, name, disabled, labelStyle, inputStyle, right, ...props }) => {
    return (
        <div className={` ` + containerStyle} >
            {label && <p
                className={'text-sm ' + labelStyle}
            >
                {label}
            </p>}
            <input
                className={`w-full h-10 py-0 px-2 outline-none border border-primary rounded-md ${disabled && 'bg-gray-200'}  ${inputStyle} ${(errors?.[name] ) && 'border-red-600'}
            } `}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                name={name}
                disabled={disabled}
                {...props}
            />
            <p className='h-5 text-xs text-red-500' >{errors?.[name]}</p>

        </div>
    )
}

export default TextInput